<template>
    <div class="roles-list">
        <div class="role-label">{{ getVerbose('permissions_select_roles') }}</div>
        <div class="role-container">
            <div
                v-for="role in concreteRoles"
                :key="role.uid"
                class="role-flex"
                @click.prevent="selectRole(role.uid)"
            >
                <el-checkbox
                    :value="selectedRoles.includes(role.uid)"
                ></el-checkbox>
                <p

                    :class="{'selected-role': selectedRoles.includes(role.uid)}"
                    class="role"
                >
                    {{ role.name }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {


    data (){
        return {
            selectedRoles: [],
        };
    },

    computed: {
        ...mapGetters([
            'concreteRoles'
        ]),
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
    },

    mounted (){

    },

    methods: {
        selectRole (uid){
            if(this.selectedRoles.includes(uid)){
                this.selectedRoles.splice(this.selectedRoles.indexOf(uid), 1);
            }else{
                this.selectedRoles.push(uid);
            }
            this.$emit('roles-selected-updated', this.selectedRoles);
        }
    },
};
</script>

<style lang="scss">
.roles-list{
    border: 1px solid #ebeef5;
    border-radius: 4px;
    .role-label{
        font-size: 16px;
        color: #303133;
        font-weight: 400;
        height: 40px;
        line-height: 40px;
        background: #f5f7fa;
        margin: 0;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
        color: #000;
        text-align: center;
    }
    .role-container{

        height: 246px;
        overflow: auto;
        background: #fff;
        .role-flex{
            display: flex;
            align-items: center;
            cursor: pointer;

            &:hover .role{
                color: #409eff;
            }

            .el-checkbox{
                margin: 0 15px;
            }
            .role{
                padding: 5px;
                margin: 0;
                display: inline;
                font-weight: 500;
                &:hover{
                    color: #409eff;
                }
            }
        }

        .selected-role{
            color: #409eff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/permissionsManagement/list-roles.vue